import i18n from "config/i18next";

i18n.addResources("es", "slots", {
  createSlot: "Crear turno",
  notDeletedSlotsTitle: "No se puede eliminar",
  notDeletedSlotsMessage: "Los siguientes slots no pueden ser cancelados:",
});
